// extracted by mini-css-extract-plugin
export default {"box":"UfoErrorList_box__c1MJg","marginTop":"UfoErrorList_marginTop__9EPpX","header":"UfoErrorList_header__6gNs8","smallHeader":"UfoErrorList_smallHeader__JoJPu"};